import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Transaction } from 'modules/Transaction/Transaction'
import { Org } from 'modules/Org/Org'

export class TransactionType extends Model {
  static override entity = 'transaction_types'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare multiplier: number

  @HasMany(() => Transaction, 'transaction_id') declare transactions: Transaction[]

  @Attr(null) declare org_id: number
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
